import React from "react";
import { DataGrid } from "@mui/x-data-grid";

const Commongrid = ({rows, columns, handleViewClick, api, setPaginationModel, paginationModel, loading, totalCount, disableColumnMenu}) => {
  return (
    <div>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationMode="server"
        rowCount={totalCount} // total rows from API
        paginationModel={paginationModel}
        onPaginationModelChange={(model) => {
          setPaginationModel(model);
          api(model.page, model.pageSize); // API call
        }}
        onRowClick={(params) => handleViewClick(params.row)}
        loading={loading}
        autoHeight
        pageSizeOptions={[20, 40, 80]}
        className="cursor-pointer"
        disableColumnMenu={disableColumnMenu}
        showToolbar
        // checkboxSelection        
      />
    </div>
  );
};

export default Commongrid;
